import CHANGELOG from './changelog';

import './styles/changelog.css';

const TYPE_LABEL = {
    feature:     'Nuevo',
    fix:         'Corrección',
    improvement: 'Mejora',
    breaking:    'Ruptura',
};

export default function ChangelogView() {
    return (
        <section className="changelog section">
            <div className="section__head">
                <div>
                    <h1 className="section__title">Historial de cambios</h1>
                    <p className="section__subtitle">
                        Versionado <code>dp&lt;mayor&gt;.&lt;menor&gt;</code> según TSS vite/06.
                    </p>
                </div>
            </div>

            <ol className="changelog__list">
                {CHANGELOG.map(release => (
                    <li className="changelog__release" key={release.version}>
                        <header className="changelog__head">
                            <span className="changelog__version">{release.version}</span>
                            <h2 className="changelog__title">{release.title}</h2>
                            <time className="changelog__date">{release.date}</time>
                        </header>

                        <ul className="changelog__notes">
                            {release.notes.map((note, index) => (
                                <li className="changelog__note" key={index}>
                                    <span className={`changelog__type changelog__type--${note.type}`}>
                                        {TYPE_LABEL[note.type] ?? note.type}
                                    </span>
                                    {note.text}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ol>
        </section>
    );
}
